<template>
  <div class="dropdown-text-button">
    <p
      v-if="title"
      class="dropdown-text-button_title"
    >
      {{ title }}<span
        v-if="required"
        class="red"
      >*</span>
    </p>
    <ValidationProvider
      v-slot="{ errors }"
      v-click-outside="$_dropdownClose"
      :rules="rules"
      class="dropdown-text-button_content-wrap"
    >
      <div
        class="dropdown-text-button_content"
        :class="{outline: outline, narrow: narrow,wide:wide,disabled:disabled,error:errors.length>0}"
      >
        <i
          v-if="leadingIcon"
          class="icon leading-icon"
          :class="leadingIcon"
        />
        <button
          class="input-button"
          @click="$_onclick()"
        >
          <p class="select">
            {{ _computedButtonTextLabel }}
          </p>
        </button>
        <i
          v-if="outline || disabled"
          class="icon trailing-icon outline icon-chevron-up"
          :class="{show: dropdownMenuShow}"
        />
        <i
          v-else-if="!outline && !dropdownMenuShow"
          class="icon trailing-icon icon-arrow-drop-down-circle"
        />
        <i
          v-else-if="!outline && dropdownMenuShow"
          class="icon trailing-icon icon-arrow-drop-up-circle"
        />
        <transition mode="out-in">
          <div
            v-if="dropdownMenuShow && !isAddActive"
            class="dropdown-menu"
          >
            <div
              v-if="btnText"
              class="dropdown-menu_btns"
            >
              <div
                v-if="btnText"
                class="dropdown-menu_btn"
                @click="$_btnClick()"
              >
                <p class="dropdown-menu_btn-text">
                  {{ preText }} <span class="blue">{{ btnText }}</span>
                </p>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div
        v-if="errors.length > 0"
        class="invalid-text"
      >
        <i class="icon-warning invalid-icon" />
        <p
          v-for="(text_e,text_k) in errors"
          :key="text_k"
          class="text"
        >
          {{ $t(text_e) }}
        </p>
      </div>
      <input
        type="hidden"
        :value="value"
      >
    </ValidationProvider>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "此項目為必填",
});
export default {
  name: "DropdownTextButton",
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: String,
      default: "",
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    selectValue: {
      type: Object,
      default() {
        return {};
      },
    },
    menuItems: {
      type: Array,
      default() {
        return [];
      },
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    outline: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    addFieldsType: {
      type: Object,
      default() {
        return {};
      },
    },
    addFields: {
      type: Object,
      default() {
        return {};
      },
    },
    addTextLabel: {
      type: String,
      default: "",
    },
    addUrl: {
      type: String,
      default: "",
    },
    preText: {
      type: String,
      default: "",
    },
    btnText: {
      type: String,
      default: "",
    },
    addLicenseTemplatePopUp: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dropdownMenuShow: false,
    isAddActive: false,
    createData: {},
    allMenuList: [],
  }),
  computed: {
    _selectValueList() {
      let allClassfication = [];
      this.allMenuList.forEach((menuItem) => {
        menuItem.menu.forEach((item) => allClassfication.push(item));
      });
      allClassfication.push(this.selectValue);
      return allClassfication;
    },
    _computedButtonTextLabel() {
      let placeholder = this.placeholder;
      let selectClassfication = [];
      this._selectValueList.forEach((system) => {
        if (this.value.includes(system.value)) {
          selectClassfication.push(system.text);
        }
      });
      if (selectClassfication.length > 0) {
        return selectClassfication.join("、");
      }
      if (placeholder) return placeholder;
      return this.menuItems[0].textLabel;
    },
  },
  watch: {
    menuItems() {
      this.allMenuList = JSON.parse(JSON.stringify(this.menuItems));
    },
  },
  mounted() {
    this.allMenuList = JSON.parse(JSON.stringify(this.menuItems));
  },
  methods: {
    $_onclick() {
      if (this.disabled) return;
      this.$_toggleDropdownMenuShow();
    },
    $_toggleDropdownMenuShow() {
      this.dropdownMenuShow = !this.dropdownMenuShow;
    },
    $_dropdownClose() {
      this.dropdownMenuShow = false;
      this.isAddActive = false;
      this.createData = {};
    },
    $_onChange($event, value) {
      let newValue = JSON.parse(JSON.stringify(this.value));
      if ($event.target.checked) {
        if (!newValue.includes(value)) {
          newValue.push(value);
        }
      } else {
        newValue = newValue.filter((item) => item !== value);
      }
      this.$emit("input", newValue);
    },
    $_addFieldOpen() {
      if (this.addLicenseTemplatePopUp) {
        this.$emit("btn-add-click");
      } else {
        this.dropdownMenuShow = false;
        this.isAddActive = true;
        this.createData = JSON.parse(JSON.stringify(this.addFields));
      }
    },
    $_addFieldClose() {
      this.isAddActive = false;
      this.createData = {};
      this.dropdownMenuShow = true;
    },
    $_btnClick() {
      this.$emit("btn-click");
    },
    async $_addSubmitClick() {
      const isValidate = await this.$refs.createObserve.validate();
      if (!isValidate) {
        return;
      }
      try {
        const res = await this.$axios.post(this.addUrl, this.createData);
        let addData = res.data.data;
        this.allMenuList.push(addData);
        this.$_dropdownClose();
      } catch (err) {
        alert(this.$t("新增發生錯誤"));
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/dropdown-text-btn.scss";
</style>